// extracted by mini-css-extract-plugin
module.exports = {"wrap":"StandaloneBookContact-module--wrap--36Zz9","info":"StandaloneBookContact-module--info--2sXIM","image":"StandaloneBookContact-module--image--2x3xc"};